import { useMemo } from 'react';
import { PointLike } from 'shared/utils/maps/clusterPoints';

const useMarkerById = <T extends PointLike>(
  markerData: T[] | null | undefined,
): Map<string, T> =>
  useMemo(() => {
    const byId = new Map<string, T>();
    (markerData ?? []).forEach((marker) => {
      byId.set(marker.id, marker);
    });
    return byId;
  }, [markerData]);

export default useMarkerById;
